var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": _vm.onSave
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('iq-card', {
    attrs: {
      "class-name": "iq-user-profile-block1"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$userDetails$perso, _vm$userDetails, _vm$userDetails$perso2, _vm$userDetails$perso3, _vm$userDetails2, _vm$userDetails2$pers, _vm$userDetails$perso4, _vm$userDetails3, _vm$userDetails3$pers, _vm$userDetails$perso5, _vm$userDetails4, _vm$userDetails4$pers, _vm$userDetails$perso6, _vm$userDetails5, _vm$userDetails5$pers, _vm$userDetails$perso7, _vm$userDetails6, _vm$userDetails6$pers, _vm$userDetails$perso8, _vm$userDetails7, _vm$userDetails7$pers;
        return [_c('div', {
          staticClass: "user-details-block"
        }, [_c('div', {
          staticClass: "user-profile text-center"
        }, [_c('img', {
          staticClass: "avatar-130 img-fluid",
          attrs: {
            "src": require("../../assets/images/user/11.png"),
            "alt": "profile-img"
          }
        })]), _c('div', {
          staticClass: "text-center mt-3"
        }, [_c('h4', [_c('b', [_vm._v(_vm._s((_vm$userDetails$perso = (_vm$userDetails = _vm.userDetails) === null || _vm$userDetails === void 0 ? void 0 : (_vm$userDetails$perso2 = _vm$userDetails.personal_data) === null || _vm$userDetails$perso2 === void 0 ? void 0 : _vm$userDetails$perso2.full_name) !== null && _vm$userDetails$perso !== void 0 ? _vm$userDetails$perso : '-'))])]), _c('p', [_vm._v(" " + _vm._s(_vm.countAge) + " Tahun, " + _vm._s((_vm$userDetails$perso3 = (_vm$userDetails2 = _vm.userDetails) === null || _vm$userDetails2 === void 0 ? void 0 : (_vm$userDetails2$pers = _vm$userDetails2.personal_data) === null || _vm$userDetails2$pers === void 0 ? void 0 : _vm$userDetails2$pers.place_of_birth) !== null && _vm$userDetails$perso3 !== void 0 ? _vm$userDetails$perso3 : '-') + " "), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Lokasi : Asam-Asam")])], 1)])]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Nomor KTP")])]), _c('td', [_vm._v(_vm._s((_vm$userDetails$perso4 = (_vm$userDetails3 = _vm.userDetails) === null || _vm$userDetails3 === void 0 ? void 0 : (_vm$userDetails3$pers = _vm$userDetails3.personal_data) === null || _vm$userDetails3$pers === void 0 ? void 0 : _vm$userDetails3$pers.nik_ktp) !== null && _vm$userDetails$perso4 !== void 0 ? _vm$userDetails$perso4 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Seaferer Code")])]), _c('td', [_vm._v(_vm._s((_vm$userDetails$perso5 = (_vm$userDetails4 = _vm.userDetails) === null || _vm$userDetails4 === void 0 ? void 0 : (_vm$userDetails4$pers = _vm$userDetails4.personal_data) === null || _vm$userDetails4$pers === void 0 ? void 0 : _vm$userDetails4$pers.seaferer_code) !== null && _vm$userDetails$perso5 !== void 0 ? _vm$userDetails$perso5 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Seaman Book")])]), _c('td', [_vm._v(_vm._s((_vm$userDetails$perso6 = (_vm$userDetails5 = _vm.userDetails) === null || _vm$userDetails5 === void 0 ? void 0 : (_vm$userDetails5$pers = _vm$userDetails5.personal_data) === null || _vm$userDetails5$pers === void 0 ? void 0 : _vm$userDetails5$pers.seaman_book_number) !== null && _vm$userDetails$perso6 !== void 0 ? _vm$userDetails$perso6 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor Passport")])]), _c('td', [_vm._v(_vm._s((_vm$userDetails$perso7 = (_vm$userDetails6 = _vm.userDetails) === null || _vm$userDetails6 === void 0 ? void 0 : (_vm$userDetails6$pers = _vm$userDetails6.personal_data) === null || _vm$userDetails6$pers === void 0 ? void 0 : _vm$userDetails6$pers.passport_number) !== null && _vm$userDetails$perso7 !== void 0 ? _vm$userDetails$perso7 : '-'))])]), _c('tr', [_c('td', [_c('strong', [_vm._v("Nomor NPWP")])]), _c('td', [_vm._v(_vm._s((_vm$userDetails$perso8 = (_vm$userDetails7 = _vm.userDetails) === null || _vm$userDetails7 === void 0 ? void 0 : (_vm$userDetails7$pers = _vm$userDetails7.personal_data) === null || _vm$userDetails7$pers === void 0 ? void 0 : _vm$userDetails7$pers.npwp_number) !== null && _vm$userDetails$perso8 !== void 0 ? _vm$userDetails$perso8 : '-'))])])])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        var _vm$userDetails$perso9, _vm$userDetails8, _vm$userDetails8$pers, _vm$userDetails$perso10, _vm$userDetails9, _vm$userDetails9$pers, _vm$userDetails$perso11, _vm$userDetails10, _vm$userDetails10$per, _vm$userDetails$perso12, _vm$userDetails11, _vm$userDetails11$per, _vm$userDetails$perso13, _vm$userDetails12, _vm$userDetails12$per, _vm$userDetails12$per2, _vm$userDetails$perso14, _vm$userDetails13, _vm$userDetails13$per, _vm$userDetails13$per2, _vm$userDetails$perso15, _vm$userDetails14, _vm$userDetails14$per, _vm$userDetails$perso16, _vm$userDetails15, _vm$userDetails15$per, _vm$userDetails15$per2, _vm$userDetails$perso17, _vm$userDetails16, _vm$userDetails16$per, _vm$userDetails$perso18, _vm$userDetails17, _vm$userDetails17$per, _vm$userDetails$perso19, _vm$userDetails18, _vm$userDetails18$per, _vm$userDetails$alama, _vm$userDetails19, _vm$userDetails19$ala, _vm$userDetails19$ala2, _vm$userDetails$alama2, _vm$userDetails20, _vm$userDetails20$ala, _vm$userDetails20$ala2;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("DATA DIRI")])]), _c('table', {
          staticClass: "table table-striped"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Apply Date")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso9 = (_vm$userDetails8 = _vm.userDetails) === null || _vm$userDetails8 === void 0 ? void 0 : (_vm$userDetails8$pers = _vm$userDetails8.personal_data) === null || _vm$userDetails8$pers === void 0 ? void 0 : _vm$userDetails8$pers.created_at) !== null && _vm$userDetails$perso9 !== void 0 ? _vm$userDetails$perso9 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Tempat / Tgl Lahir")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso10 = (_vm$userDetails9 = _vm.userDetails) === null || _vm$userDetails9 === void 0 ? void 0 : (_vm$userDetails9$pers = _vm$userDetails9.personal_data) === null || _vm$userDetails9$pers === void 0 ? void 0 : _vm$userDetails9$pers.place_of_birth) !== null && _vm$userDetails$perso10 !== void 0 ? _vm$userDetails$perso10 : '-') + " / " + _vm._s((_vm$userDetails$perso11 = (_vm$userDetails10 = _vm.userDetails) === null || _vm$userDetails10 === void 0 ? void 0 : (_vm$userDetails10$per = _vm$userDetails10.personal_data) === null || _vm$userDetails10$per === void 0 ? void 0 : _vm$userDetails10$per.date_of_birth) !== null && _vm$userDetails$perso11 !== void 0 ? _vm$userDetails$perso11 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Kewarganegaraan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso12 = (_vm$userDetails11 = _vm.userDetails) === null || _vm$userDetails11 === void 0 ? void 0 : (_vm$userDetails11$per = _vm$userDetails11.personal_data) === null || _vm$userDetails11$per === void 0 ? void 0 : _vm$userDetails11$per.citizenship) !== null && _vm$userDetails$perso12 !== void 0 ? _vm$userDetails$perso12 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Status Pernikahan")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso13 = (_vm$userDetails12 = _vm.userDetails) === null || _vm$userDetails12 === void 0 ? void 0 : (_vm$userDetails12$per = _vm$userDetails12.personal_data) === null || _vm$userDetails12$per === void 0 ? void 0 : (_vm$userDetails12$per2 = _vm$userDetails12$per.marital_status) === null || _vm$userDetails12$per2 === void 0 ? void 0 : _vm$userDetails12$per2.name) !== null && _vm$userDetails$perso13 !== void 0 ? _vm$userDetails$perso13 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Agama")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso14 = (_vm$userDetails13 = _vm.userDetails) === null || _vm$userDetails13 === void 0 ? void 0 : (_vm$userDetails13$per = _vm$userDetails13.personal_data) === null || _vm$userDetails13$per === void 0 ? void 0 : (_vm$userDetails13$per2 = _vm$userDetails13$per.religion) === null || _vm$userDetails13$per2 === void 0 ? void 0 : _vm$userDetails13$per2.name) !== null && _vm$userDetails$perso14 !== void 0 ? _vm$userDetails$perso14 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Jumlah Anak")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso15 = (_vm$userDetails14 = _vm.userDetails) === null || _vm$userDetails14 === void 0 ? void 0 : (_vm$userDetails14$per = _vm$userDetails14.personal_data) === null || _vm$userDetails14$per === void 0 ? void 0 : _vm$userDetails14$per.number_of_children) !== null && _vm$userDetails$perso15 !== void 0 ? _vm$userDetails$perso15 : '-') + " Orang")])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Golongan Darah")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso16 = (_vm$userDetails15 = _vm.userDetails) === null || _vm$userDetails15 === void 0 ? void 0 : (_vm$userDetails15$per = _vm$userDetails15.personal_data) === null || _vm$userDetails15$per === void 0 ? void 0 : (_vm$userDetails15$per2 = _vm$userDetails15$per.blood_type) === null || _vm$userDetails15$per2 === void 0 ? void 0 : _vm$userDetails15$per2.alias) !== null && _vm$userDetails$perso16 !== void 0 ? _vm$userDetails$perso16 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Nomor Tlp/Hp")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso17 = (_vm$userDetails16 = _vm.userDetails) === null || _vm$userDetails16 === void 0 ? void 0 : (_vm$userDetails16$per = _vm$userDetails16.personal_data) === null || _vm$userDetails16$per === void 0 ? void 0 : _vm$userDetails16$per.hp_number) !== null && _vm$userDetails$perso17 !== void 0 ? _vm$userDetails$perso17 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Jenis Kelamin")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso18 = (_vm$userDetails17 = _vm.userDetails) === null || _vm$userDetails17 === void 0 ? void 0 : (_vm$userDetails17$per = _vm$userDetails17.personal_data) === null || _vm$userDetails17$per === void 0 ? void 0 : _vm$userDetails17$per.gender) !== null && _vm$userDetails$perso18 !== void 0 ? _vm$userDetails$perso18 : '-'))]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Email")])]), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$perso19 = (_vm$userDetails18 = _vm.userDetails) === null || _vm$userDetails18 === void 0 ? void 0 : (_vm$userDetails18$per = _vm$userDetails18.personal_data) === null || _vm$userDetails18$per === void 0 ? void 0 : _vm$userDetails18$per.email) !== null && _vm$userDetails$perso19 !== void 0 ? _vm$userDetails$perso19 : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Alamat")])]), _c('td', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$alama = (_vm$userDetails19 = _vm.userDetails) === null || _vm$userDetails19 === void 0 ? void 0 : (_vm$userDetails19$ala = _vm$userDetails19.alamat_ktp) === null || _vm$userDetails19$ala === void 0 ? void 0 : (_vm$userDetails19$ala2 = _vm$userDetails19$ala[0]) === null || _vm$userDetails19$ala2 === void 0 ? void 0 : _vm$userDetails19$ala2.alamat) !== null && _vm$userDetails$alama !== void 0 ? _vm$userDetails$alama : '-'))])]), _c('tr', [_c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_c('strong', [_vm._v("Alamat Domisili")])]), _c('td', {
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v(_vm._s((_vm$userDetails$alama2 = (_vm$userDetails20 = _vm.userDetails) === null || _vm$userDetails20 === void 0 ? void 0 : (_vm$userDetails20$ala = _vm$userDetails20.alamat_domisili) === null || _vm$userDetails20$ala === void 0 ? void 0 : (_vm$userDetails20$ala2 = _vm$userDetails20$ala[0]) === null || _vm$userDetails20$ala2 === void 0 ? void 0 : _vm$userDetails20$ala2.alamat) !== null && _vm$userDetails$alama2 !== void 0 ? _vm$userDetails$alama2 : '-'))])])])])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$userDetails21, _vm$userDetails21$per, _vm$userDetails21$per2, _vm$userDetails21$per3, _vm$userDetails22, _vm$userDetails22$per, _vm$userDetails22$per2, _vm$userDetails22$per3;
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("FORMULIR WAWANCARA " + _vm._s((_vm$userDetails21 = _vm.userDetails) === null || _vm$userDetails21 === void 0 ? void 0 : (_vm$userDetails21$per = _vm$userDetails21.personal_data) === null || _vm$userDetails21$per === void 0 ? void 0 : (_vm$userDetails21$per2 = _vm$userDetails21$per.position) === null || _vm$userDetails21$per2 === void 0 ? void 0 : (_vm$userDetails21$per3 = _vm$userDetails21$per2.name) === null || _vm$userDetails21$per3 === void 0 ? void 0 : _vm$userDetails21$per3.toUpperCase()) + " / "), _c('i', [_vm._v(_vm._s((_vm$userDetails22 = _vm.userDetails) === null || _vm$userDetails22 === void 0 ? void 0 : (_vm$userDetails22$per = _vm$userDetails22.personal_data) === null || _vm$userDetails22$per === void 0 ? void 0 : (_vm$userDetails22$per2 = _vm$userDetails22$per.position) === null || _vm$userDetails22$per2 === void 0 ? void 0 : (_vm$userDetails22$per3 = _vm$userDetails22$per2.name) === null || _vm$userDetails22$per3 === void 0 ? void 0 : _vm$userDetails22$per3.toUpperCase()) + " INTERVIEW FORM")])])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-button', {
          staticClass: "float-right ml-3",
          attrs: {
            "type": "submit",
            "variant": "primary"
          },
          on: {
            "click": _vm.onSave
          }
        }, [_c('i', {
          staticClass: "fa fa-save"
        }), _vm._v(" Save")]), _c('b-button', {
          staticClass: "iq-bg-danger float-right",
          attrs: {
            "type": "reset",
            "variant": "none"
          },
          on: {
            "click": _vm.resetForm
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v(" Reset Form")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, _vm._l(_vm.interview_questions, function (interview, keyInterview) {
          return _c('fieldset', {
            key: keyInterview,
            staticClass: "form-group border p-3"
          }, [_c('legend', {
            staticClass: "w-auto px-2",
            staticStyle: {
              "font-size": "12pt"
            }
          }, [_vm._v(_vm._s(interview === null || interview === void 0 ? void 0 : interview.name))]), _c('b-row', [_c('b-col', {
            attrs: {
              "md": "12"
            }
          }, [_c('table', {
            staticClass: "table table-striped"
          }, [_c('thead', [_c('tr', {
            staticClass: "text-center"
          }, [_c('th', {
            attrs: {
              "width": "45%"
            }
          }), _vm._l(_vm.point_interview, function (item, index) {
            return _c('th', {
              key: index,
              attrs: {
                "width": "15%"
              }
            }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.name) + " "), _c('br'), _vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.value_letter))]);
          })], 2)]), _c('tbody', _vm._l(interview.data_criteria, function (criteria, keyCriteria) {
            return _c('tr', {
              key: keyCriteria
            }, [_c('th', [_vm._v(_vm._s(criteria.content)), _c('br')]), _vm._l(criteria === null || criteria === void 0 ? void 0 : criteria.point, function (point, keyPoint) {
              return _c('td', {
                key: keyPoint,
                staticClass: "text-center"
              }, [[_c('b-form-checkbox', {
                staticClass: "ml-4",
                attrs: {
                  "name": "check-button",
                  "switch": "",
                  "inline": ""
                },
                on: {
                  "change": function change($event) {
                    return _vm.selectMenus(point, keyInterview, keyCriteria, keyPoint);
                  }
                },
                model: {
                  value: point.checked,
                  callback: function callback($$v) {
                    _vm.$set(point, "checked", $$v);
                  },
                  expression: "point.checked"
                }
              })]], 2);
            })], 2);
          }), 0)]), _c('label', {
            attrs: {
              "for": "komentar"
            }
          }, [_c('strong', [_vm._v("Komentar")])]), _c('b-form-textarea', {
            attrs: {
              "rows": "2",
              "value": "Comments if any / Komentar jika ada",
              "required": ""
            },
            model: {
              value: interview.comment,
              callback: function callback($$v) {
                _vm.$set(interview, "comment", $$v);
              },
              expression: "interview.comment"
            }
          })], 1)], 1)], 1);
        }), 0)], 1), _c('hr'), _c('b-row', {
          staticClass: "mt-3"
        }, [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "Clasification *",
            "for": "nama_kandidiat"
          }
        }, [_c('strong', [_vm._v("Wawancara Oleh")]), _c('br'), _c('i', [_vm._v("Interview by")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "id": "job_name",
            "type": "text",
            "placeholder": "Nama",
            "required": ""
          },
          model: {
            value: _vm.wawancara_oleh,
            callback: function callback($$v) {
              _vm.wawancara_oleh = $$v;
            },
            expression: "wawancara_oleh"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "Clasification *",
            "for": "nama_kandidiat"
          }
        }, [_c('strong', [_vm._v("Hasil Wawancara")]), _c('br'), _c('i', [_vm._v("Result Interview")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.wawancara,
            "size": "lg",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Hasil Wawancara")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.hasil_wawancara,
            callback: function callback($$v) {
              _vm.hasil_wawancara = $$v;
            },
            expression: "hasil_wawancara"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "Clasification *",
            "for": "nama_kandidiat"
          }
        }, [_c('strong', [_vm._v("Urgensi Wawancara")]), _c('br'), _c('i', [_vm._v("Interview Urgency")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-select', {
          attrs: {
            "plain": "",
            "options": _vm.optionsUrgensi,
            "size": "lg",
            "required": ""
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("None")])];
            },
            proxy: true
          }]),
          model: {
            value: _vm.urgensi,
            callback: function callback($$v) {
              _vm.urgensi = $$v;
            },
            expression: "urgensi"
          }
        })], 1)]), _c('div', {
          staticClass: "form-group row"
        }, [_c('label', {
          staticClass: "col-sm-6",
          attrs: {
            "label": "Clasification *",
            "for": "nama_kandidiat"
          }
        }, [_c('strong', [_vm._v("Lokasi Wawancara")]), _c('br'), _c('i', [_vm._v("Interview Location")])]), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('b-form-input', {
          attrs: {
            "id": "location",
            "type": "text",
            "placeholder": "Lokasi Wawancara",
            "required": ""
          },
          model: {
            value: _vm.location,
            callback: function callback($$v) {
              _vm.location = $$v;
            },
            expression: "location"
          }
        })], 1)])]), _c('b-col', {
          staticClass: "mt-3",
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          attrs: {
            "disabled": _vm.saving,
            "variant": "primary",
            "block": "",
            "type": "submit"
          }
        }, [_vm.saving ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _vm._e(), !_vm.saving ? _c('i', {
          staticClass: "fa fa-file-signature"
        }) : _vm._e(), !_vm.saving ? _c('span', [_vm._v("Save")]) : _vm._e()]), _c('b-button', {
          staticClass: "iq-bg-danger float-right",
          attrs: {
            "type": "reset",
            "block": "",
            "variant": "none"
          },
          on: {
            "click": _vm.resetForm
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v(" Reset Form")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }